module.exports = __webpack_public_path__ + "static/media/product3.a0e40011.jpg";